import { ANALYTICS_SETTING } from "@/setting/setting";
import { addItemCartAnalytics } from "../analytics/analytics.api";
import { TrackTypes } from "./track";

export const binextTrack = (event: TrackTypes, data: Record<string, any> = {}) => 
{
    if (typeof window === "undefined") return;

    // Facebook Pixel
    if (ANALYTICS_SETTING.status) 
    {
        if (event == TrackTypes.AddToCart)
        {
            addItemCartAnalytics(data?.product, data?.variant);
        }
        else if (event == TrackTypes.ViewContent)
        {
            //
        }
        else if (event == TrackTypes.AddToWishlist)
        {
            //
        }
        else if (event == TrackTypes.Search)
        {
            //
        }
        else if (event == TrackTypes.PageView)
        {
            //
        }
        else if (event == TrackTypes.CompleteRegistration || event == TrackTypes.Lead)
        {
            //
        }
        else if (event == TrackTypes.InitiateCheckout || event == TrackTypes.AddPaymentInfo)
        {
            //
        }
        else if (event == TrackTypes.Purchase)
        {
            //
        }                        
    }
};